export const dialogSize = {
  XS: 'shr-w-col3',
  S: 'shr-w-col4',
  M: 'shr-w-col5',
  L: 'shr-w-col6',
  XL: 'shr-w-col7',
  XXL: 'shr-w-col8',
  FULL: 'shr-w-full',
} as const
